module.exports = __webpack_public_path__ + "assets/img/img241.691082fc.png";